export const generateTextWidth = (text, font) => {
  // biome-ignore lint/style/useConst: migrated from develop
  let canvas =
    generateTextWidth.canvas ||
    (generateTextWidth.canvas = document.createElement('canvas'));
  // biome-ignore lint/style/useConst: migrated from develop
  let context = canvas.getContext('2d');
  context.font = font;
  // biome-ignore lint/style/useConst: migrated from develop
  let metrics = context.measureText(text);
  return metrics.width;
};
